import router from "@/router";
import { ethers } from "ethers";
import store from "@/store";
const INFO = {
  usdtAddress: "0xb913d97e86F048356c545C54b428be7cD4DcD565",
  // 天晟链质押合约
  depositAddress: "0xE37F140CdaF99Eb73Fc01aed042E022b88962d61",
  // 天晟链质押ABI
  idoabi: [
    "function pay(address token, uint256 amount, string calldata uuid, string calldata typeValue) external",
  ],
  tokenabi: [
    "function transfer( address recipient, uint256 amount ) external returns (bool)",
    "function allowance(address owner, address spender) external view returns (uint256)",
    "function approve(address spender, uint256 amount) external returns (bool)",
    "function balanceOf(address account) external view returns (uint256)",
    "function symbol() external view returns (string memory)",
    "function decimals() external pure returns (uint8)",
    "function totalSupply() external view returns (uint256)",
  ],
  // 天晟链提现合约
  withdrawaddr: "0x484dd812ee651A0d846fde418F2472035df90288",
  usdtAddr: "0xb913d97e86F048356c545C54b428be7cD4DcD565",
  // 提现方法
  withdrawabi: [
    "function nonces(address) view returns (uint256)",
    "function withdraw(address token, uint256 amount, uint256 nonce, uint256 transferTime, string calldata uuid, string calldata typeValue, bytes calldata signature) external",
  ],
};

let useAccount = null;
const connectWallet = async () => {
  try {
    if (!useAccount) {
      await connectMetamask();
      return useAccount;
    } else {
      return useAccount;
    }
  } catch (connectError) {
    return {
      err: connectError,
    };
  }
};

const connectMetamask = async () => {
  let provider;
  if (window.bitkeep && window.bitkeep.ethereum) {
    provider = new ethers.providers.Web3Provider(window.bitkeep.ethereum);
  } else if (window.ethereum) {
    provider = new ethers.providers.Web3Provider(window.ethereum);
  } else {
    alert("请安装 Bitget 钱包或其他以太坊兼容钱包");
    return;
  }
  try {
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    useAccount = await signer.getAddress();
    provider.provider.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        useAccount = ethers.utils.getAddress(accounts[0]);
        sessionStorage.clear();
        store.dispatch("clearAuthData");
        if (router.currentRoute.path !== "/") {
          router.push("/");
        }
      } else {
        useAccount = null;
      }
    });
  } catch (error) {
    console.error("钱包连接失败:", error);
  }
};
// 支付方法
const deposit = async (usdtAddr, amount, uuid) => {
  try {
    if (!window.ethereum)
      return {
        error: true,
        msg: "please connect wallet",
      };

    if (!useAccount) await connectWallet();
    let provider;
    if (window.bitkeep && window.bitkeep.ethereum) {
      provider = new ethers.providers.Web3Provider(window.bitkeep.ethereum);
    } else if (window.ethereum) {
      provider = new ethers.providers.Web3Provider(window.ethereum);
    } else {
      return;
    }
    const signer = provider.getSigner();

    const token = new ethers.Contract(usdtAddr, INFO.tokenabi, signer);

    const allowance = await token.allowance(useAccount, INFO.depositAddress);
    if (allowance.lt(ethers.utils.parseUnits(amount, 18))) {
      const tx = await token.approve(
        INFO.depositAddress,
        ethers.constants.MaxUint256
      );

      await tx.wait();
    }

    const ido = new ethers.Contract(INFO.depositAddress, INFO.idoabi, signer);

    const tx = await ido.pay(
      usdtAddr,
      ethers.utils.parseUnits(amount, 18),
      uuid,
      "1"
    );
    return tx;
  } catch (error) {
    // console.log(error, "error")
    return error;
  }
};

// let DEFAULT_CHAIN_PARAMS = {
//   chainId: "0x54c5638",
//   chainName: "TESENET",
//   nativeCurrency: { name: "TESETH", symbol: "TESETH", decimals: 18 },
//   rpcUrls: ["https://rpc.skysp.info/"],
// };
const DEFAULT_CHAIN_PARAMS = {
  chainId: "0x38",
  chainName: "BNB Smart Chain",
  nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
  rpcUrls: ["https://bsc-dataseed.binance.org/"],
  blockExplorerUrls: ["https://bscscan.com/"],
};
const toHexChainId = (id) => {
  if (!id) return null;
  // 已是 0x 前缀则直接返回
  if (typeof id === "string" && id.startsWith("0x")) return id;
  // 如果是字符串数字或数字，转成 0x hex
  const n = Number(id);
  if (Number.isFinite(n)) return "0x" + n.toString(16);
  return null;
};

const getChain = async () => {
  const rawTarget = process.env.VUE_APP_BASE_CHAIN_ID;

  const targetChainId = toHexChainId(rawTarget) || DEFAULT_CHAIN_PARAMS.chainId;
  let provider = null;
  if (window.tokenpocket && window.tokenpocket.ethereum) {
    provider = window.tokenpocket.ethereum;
  } else if (window.ethereum) {
    provider = window.ethereum;
  }

  if (!provider) {
    console.warn("No web3 provider found.");
    return false;
  }

  try {
    // 获取当前链 id
    let chainId = await provider.request({ method: "eth_chainId" });

    if (chainId === targetChainId) return true;

    // 针对 TokenPocket 等可能返回 "0x1" 的特殊处理也是一样尝试切换
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: targetChainId }],
      });

      // 切换后再确认一次
      const newChainId = await provider.request({ method: "eth_chainId" });

      return newChainId === targetChainId;
    } catch (switchError) {
      // 如果是 unknown chain（4902），尝试添加链
      const errCode =
        switchError && (switchError.code || switchError.error?.code);
      if (
        errCode === 4902 ||
        (switchError && /4902/.test(String(switchError)))
      ) {
        // 使用默认 BSC 参数，或替换为你自己的链参数
        const addParams = {
          chainId: targetChainId,
          chainName: DEFAULT_CHAIN_PARAMS.chainName,
          rpcUrls: DEFAULT_CHAIN_PARAMS.rpcUrls,
          nativeCurrency: DEFAULT_CHAIN_PARAMS.nativeCurrency,
        };
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [addParams],
          });

          // 添加后尝试切换
          await provider.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: targetChainId }],
          });

          const afterAddChainId = await provider.request({
            method: "eth_chainId",
          });

          return afterAddChainId === targetChainId;
        } catch (addError) {
          console.error("wallet_addEthereumChain / 再次切换失败:", addError);
          return false;
        }
      }

      // 其他错误（用户拒绝、钱包不支持等）
      return false;
    }
  } catch (err) {
    console.error("检测/切换链时出错:", err);
    return false;
  }
};

// 获取代币余额[钱包地址，代币地址]
const getBTCBalance = async (address, iconAddr) => {
  if (!window.ethereum)
    return {
      error: true,
      msg: "please connect wallet",
    };
  if (!useAccount) await connectWallet();
  // 连接钱包
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();
  const contract = new ethers.Contract(
    iconAddr,
    ["function balanceOf(address account) external view returns (uint256)"],
    signer
  );
  const balance = await contract.balanceOf(address);
  return ethers.utils.formatEther(balance);
};

//获取提现签名
let withdrawasnonce = async () => {
  if (!window.ethereum)
    return {
      error: true,
      msg: "please connect wallet",
    };
  if (!useAccount) await connectWallet();
  let provider = new ethers.providers.Web3Provider(window.ethereum);
  let signer = provider.getSigner();
  const contract = new ethers.Contract(
    INFO.withdrawaddr,
    INFO.withdrawabi,
    signer
  );
  const tx = await contract.nonces(useAccount);
  return tx.toString();
};
// HMS 普通提现
let withdrawToken = async (
  tokenAddr,
  amount,
  nonce,
  transferTime,
  uuid,
  typeValue,
  signature
) => {
  if (!window.ethereum)
    return {
      error: true,
      msg: "please connect wallet",
    };
  if (!useAccount) await connectWallet();

  let provider = new ethers.providers.Web3Provider(window.ethereum);
  let signer = provider.getSigner();
  const userAddress = await signer.getAddress();
  const contract = new ethers.Contract(
    INFO.withdrawaddr,
    INFO.withdrawabi,
    signer
  );

  const tx = await contract.withdraw(
    tokenAddr,
    ethers.utils.parseUnits(amount, 18),
    nonce,
    transferTime,
    uuid,
    typeValue,
    signature
  );
  return tx;
};

export {
  connectWallet,
  getChain,
  getBTCBalance,
  INFO,
  deposit,
  //HMS 获取提现签名
  withdrawasnonce,
  //HMS 普通提现
  withdrawToken,
};
